import { ExpMultipins } from '../../constants/config/declarations';

export function useIsMultipinsExpActive(): boolean {
  return ExpMultipins.use() === 'B';
}
